import { useTheme } from "@up/data";
import { Toast } from "@up/ui";

import { useCart } from "../CartContext";
import FinalAgreement from "../FinalAgreement";
import { SubmitButton } from "../SubmitButton";

import type { MouseEvent } from "react";

type Props = {
  onSubmit: () => void;
};

export const PaymentFree = function PaymentFree({ onSubmit }: Props) {
  const theme = useTheme();
  const cart = useCart();

  const isSubmitting = cart.isSubmitting || cart.isValidating;
  const { submitAsCompleteDidError: didError, checkoutErrorMessage } = cart;

  const submitButtonText = isSubmitting
    ? "Processing..."
    : "Complete Your Enrollment";

  return (
    <>
      {checkoutErrorMessage ? (
        <div
          className="mt-0 mb-4 pt-4"
          data-testid="submit-as-complete-error-message"
        >
          <Toast variant="error">{checkoutErrorMessage}</Toast>
        </div>
      ) : didError ? (
        <div
          className="mt-0 mb-4 pt-4"
          data-testid="submit-as-complete-error-message"
        >
          <Toast variant="error">
            We could not complete your checkout. Please try again or contact
            support at{" "}
            <a className="underline" href={`mailto:${theme.supportEmail}`}>
              {theme.supportEmail}
            </a>
          </Toast>
        </div>
      ) : null}

      <div>
        <FinalAgreement />
        <br />
        <div className="md:flex items-center justify-between">
          <SubmitButton
            disabled={isSubmitting}
            isSubmitting={isSubmitting}
            onClick={(event: MouseEvent<HTMLButtonElement>) => {
              event.preventDefault();
              onSubmit();
            }}
            data-testid="button-isfree"
          >
            {submitButtonText}
          </SubmitButton>
        </div>
      </div>
    </>
  );
};
